import { Observable } from "rxjs";
import { FiltroInformeNhCenso } from "../entity/filtro-informe-nh-censo.model";
import { TipoInformeNh } from "../entity/tipo-informe.model";
import { ArchivoInformeResult } from "../../../../../infraestructure/response-model/informes/informe-descarga.response";

export abstract class InformesNhGateway {

    abstract consultarInformesNh(codigoTipo: number): Observable<TipoInformeNh[]>;
    abstract consultarInformeNhCenso(filtros: FiltroInformeNhCenso): Observable<ArchivoInformeResult>;
    abstract consultarInformeNhRespaldoProgramacion(filtros: FiltroInformeNhCenso): Observable<ArchivoInformeResult>;

}
